import React, { useEffect, createElement } from 'react';
interface PageMetaProps {
  title: string;
  description: string;
  ogImage?: string;
  url?: string;
  type?: string;
}
function setMetaTag(attribute: string, key: string, content: string) {
  let element = document.querySelector(`meta[${attribute}="${key}"]`);
  if (element) {
    element.setAttribute('content', content);
  } else {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    element.setAttribute('content', content);
    document.head.appendChild(element);
  }
}
function setLinkTag(rel: string, href: string) {
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (element) {
    element.setAttribute('href', href);
  } else {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    element.setAttribute('href', href);
    document.head.appendChild(element);
  }
}
export function PageMeta({
  title,
  description,
  ogImage,
  url,
  type = 'website'
}: PageMetaProps) {
  useEffect(() => {
    // Page title
    document.title = title;
    // Standard meta
    setMetaTag('name', 'description', description);
    // Open Graph
    setMetaTag('property', 'og:title', title);
    setMetaTag('property', 'og:description', description);
    setMetaTag('property', 'og:type', type);
    if (url) {
      setMetaTag('property', 'og:url', url);
      setLinkTag('canonical', url);
    }
    if (ogImage) {
      setMetaTag('property', 'og:image', ogImage);
    }
    // Twitter Card
    setMetaTag('name', 'twitter:card', 'summary');
    setMetaTag('name', 'twitter:title', title);
    setMetaTag('name', 'twitter:description', description);
    if (ogImage) {
      setMetaTag('name', 'twitter:image', ogImage);
    }
  }, [title, description, ogImage, url, type]);
  return null;
}